if (!customElements.get("facet-filters-form")) {
  class FacetFiltersForm extends HTMLElement {
    constructor() {
      super();

      this.sectionId = this.dataset.sectionId;
      this.form = this.querySelector("form");
      this.onSubmitHandler = this.onSubmitHandler.bind(this);
      this.onChangeHandler = this.onChangeHandler.bind(this);
      this.onPopStateHandler = this.onPopStateHandler.bind(this);
    }

    connectedCallback() {
      if (!this.form) return;

      this.form.addEventListener("submit", this.onSubmitHandler);
      this.form.addEventListener("change", this.onChangeHandler);
      window.addEventListener("popstate", this.onPopStateHandler);
    }

    disconnectedCallback() {
      if (!this.form) return;

      this.form.removeEventListener("submit", this.onSubmitHandler);
      this.form.removeEventListener("change", this.onChangeHandler);
      window.removeEventListener("popstate", this.onPopStateHandler);
    }

    onSubmitHandler(event) {
      event.preventDefault();
      this.renderPage();
    }

    onChangeHandler() {
      this.renderPage();
    }

    onPopStateHandler() {
      this.renderFromUrl(window.location.search.replace(/^\?/, ""));
    }

    createSearchParams() {
      const formData = new FormData(this.form);
      const searchParams = new URLSearchParams();

      for (const [key, value] of formData.entries()) {
        if (value !== "") {
          searchParams.append(key, value);
        }
      }

      return searchParams.toString();
    }

    renderPage() {
      const searchParams = this.createSearchParams();
      this.renderFromUrl(searchParams, true);
    }

    renderFromUrl(searchParams, updateHistory = false) {
      const url = `${window.location.pathname}?section_id=${this.sectionId}${searchParams ? `&${searchParams}` : ""}`;

      this.classList.add("is-loading");

      fetch(url, {
        method: "GET",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      })
        .then((response) => response.text())
        .then((responseText) => {
          const parser = new DOMParser();
          const newDocument = parser.parseFromString(responseText, "text/html");

          const currentSection = document.querySelector(
            `#CollectionSection-${this.sectionId}`,
          );
          const newSection = newDocument.querySelector(
            `#CollectionSection-${this.sectionId}`,
          );

          if (!currentSection || !newSection) return;

          const currentFilters = currentSection.querySelector(
            "[data-filters-container]",
          );

          const newFilters = newSection.querySelector(
            "[data-filters-container]",
          );

          const currentActiveFilters = currentSection.querySelector(
            "[data-active-filters]",
          );

          const newActiveFilters = newSection.querySelector(
            "[data-active-filters]",
          );

          const currentGrid = currentSection.querySelector(
            "[data-product-grid]",
          );

          const newGrid = newSection.querySelector("[data-product-grid]");

          const currentCount = currentSection.querySelector(
            "[data-products-count]",
          );

          const newCount = newSection.querySelector("[data-products-count]");

          if (currentFilters && newFilters) {
            currentFilters.innerHTML = newFilters.innerHTML;
          }

          if (currentActiveFilters && newActiveFilters) {
            currentActiveFilters.innerHTML = newActiveFilters.innerHTML;
          }

          if (currentGrid && newGrid) {
            currentGrid.innerHTML = newGrid.innerHTML;
            if (typeof initRevealCards === "function") {
              initRevealCards(currentGrid);
            }
          }

          if (currentCount && newCount) {
            currentCount.innerHTML = newCount.innerHTML;
          }

          const currentPagination = currentSection.querySelector(
            "[data-pagination-container]",
          );
          const newPagination = newSection.querySelector(
            "[data-pagination-container]",
          );
          if (currentPagination && newPagination) {
            currentPagination.innerHTML = newPagination.innerHTML;
          }

          if (updateHistory) {
            const nextUrl = `${window.location.pathname}${searchParams ? `?${searchParams}` : ""}`;
            window.history.pushState({}, "", nextUrl);
          }
        })
        .catch((error) => {
          console.error("Errore aggiornamento filtri:", error);
        })
        .finally(() => {
          this.classList.remove("is-loading");
          document.dispatchEvent(new CustomEvent("collection:updated"));
        });
    }
  }

  customElements.define("facet-filters-form", FacetFiltersForm);
}

document.addEventListener("click", function (e) {
  const btn = e.target.closest("[data-load-more]");
  if (!btn || btn.disabled) return;

  e.preventDefault();

  const nextUrl = btn.dataset.nextUrl;
  if (!nextUrl) return;

  const sectionEl = document.querySelector("[data-collection-section]");
  const sectionId = document
    .querySelector("facet-filters-form")
    ?.dataset.sectionId;

  if (!sectionEl || !sectionId) return;

  btn.disabled = true;
  btn.classList.add("opacity-50", "cursor-not-allowed");

  const separator = nextUrl.includes("?") ? "&" : "?";
  const fetchUrl = `${nextUrl}${separator}section_id=${sectionId}`;

  fetch(fetchUrl, {
    headers: { "X-Requested-With": "XMLHttpRequest" },
  })
    .then((r) => r.text())
    .then((html) => {
      const parser = new DOMParser();
      const newDoc = parser.parseFromString(html, "text/html");
      const newSection = newDoc.querySelector(
        `#CollectionSection-${sectionId}`,
      );
      if (!newSection) return;

      const grid = sectionEl.querySelector("[data-product-grid]");
      const newGrid = newSection.querySelector("[data-product-grid]");
      if (grid && newGrid) {
        grid.insertAdjacentHTML("beforeend", newGrid.innerHTML);
        if (typeof initRevealCards === "function") {
          initRevealCards(grid);
        }
      }

      const pagination = sectionEl.querySelector("[data-pagination-container]");
      const newPagination = newSection.querySelector(
        "[data-pagination-container]",
      );
      if (pagination && newPagination) {
        pagination.innerHTML = newPagination.innerHTML;
      }

      window.history.pushState({}, "", nextUrl);
      document.dispatchEvent(new CustomEvent("collection:updated"));
    })
    .catch((err) => {
      console.error("Load more error:", err);
      btn.disabled = false;
      btn.classList.remove("opacity-50", "cursor-not-allowed");
    });
});
